import { EntityAction } from '../../interfaces/entity-actions';
import { Tooltip } from '../../../tooltip/Tooltip';
import { Button } from '../../../button/Button';
import styles from './EntityInlineActions.module.scss';
import { IconButton } from '../../../button/IconButton/IconButton';
import { Icon } from '../../../icon/Icon';
import { LinkButton } from '../../../link/LinkButton';

export function EntityInlineActions<A extends string | number | symbol>({
  actions,
  onActionClick
}: {
  actions: EntityAction<A>[];
  onActionClick: (actions: EntityAction<A>) => void;
}) {
  return (
    <>
      {actions.map(action => {
        if (action.CustomAction) {
          return action.CustomAction;
        }

        return (
          <Tooltip
            dataId={action.action.toString()}
            title={action.disabledReason}
            disabled={!action.disabled}
            key={action.type}
          >
            <div>
              {action.type === 'INLINE' ? (
                <Button
                  dataId={action.action.toString()}
                  icon={action.icon}
                  direction='left'
                  variation='outline'
                  size='sm'
                  className={styles.inlineAction}
                  disabled={action.disabled}
                  {...action.inlineOptions}
                  onClick={() => onActionClick(action)}
                >
                  {action.displayName}
                </Button>
              ) : null}

              {action.type === 'INLINE_ICON' ? (
                <IconButton
                  dataId={action.action.toString()}
                  label={action.displayName}
                  className={styles.inlineAction}
                  {...action.inlineIconOptions}
                  onClick={() => onActionClick(action)}
                >
                  <Icon name={action.icon} className={action.iconClass} size={action.iconSize} />
                </IconButton>
              ) : null}

              {action.type === 'INLINE_LINK' ? (
                <LinkButton
                  dataId={action.action.toString()}
                  className={styles.inlineAction}
                  {...action.inlineLinkOptions}
                  onClick={() => onActionClick(action)}
                >
                  {action.displayName}
                </LinkButton>
              ) : null}
            </div>
          </Tooltip>
        );
      })}
    </>
  );
}
